import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5716378c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = { class: "ant-row ui-espaco-campos" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { title: "1. Valor Target do Prêmio - (VR) - R$" }, " 1. Valor Target do Prêmio - (VR) - R$: ", -1))
const _hoisted_5 = { title: "Observações" }
const _hoisted_6 = { class: "ant-row ui-espaco-campos" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = { title: "2. Seguro Novo ou Renovação" }
const _hoisted_9 = { title: "Observações" }
const _hoisted_10 = { class: "ant-row ui-espaco-campos" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { title: "3. CIA Seguradora Atual (Apólice Vigente)" }, " 3. CIA Seguradora Atual (Apólice Vigente) ", -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { title: "Observações" }
const _hoisted_15 = { class: "ant-row ui-espaco-campos" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { title: "4. Data de Vigência/Renovação" }, " 4. Data de Vigência/Renovação: ", -1))
const _hoisted_18 = { title: "Observações" }
const _hoisted_19 = { class: "ant-row ui-espaco-campos" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { title: "5. Valores em Risco Total (VR) - R$" }, " 5. VALORES EM RISCO TOTAL (VR) - R$: ", -1))
const _hoisted_22 = { class: "ui-valores-subcampo" }
const _hoisted_23 = { title: "VR - Prédio (Estrutura)" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Valor:", -1))
const _hoisted_26 = { title: "Observações" }
const _hoisted_27 = { class: "ui-valores-subcampo" }
const _hoisted_28 = { title: "VR - Conteúdo (Máquinas, equipamentos, móveis, utensílios, instalações e demais bens)" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { title: "Valor" }
const _hoisted_31 = { title: "Observações" }
const _hoisted_32 = { class: "ui-valores-subcampo" }
const _hoisted_33 = { title: "VR - Estoques (Matéria-prima, produtos em processo, acabados, embalagens e materiais auxiliares)" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { title: "Valor" }
const _hoisted_36 = { title: "Observações" }
const _hoisted_37 = { class: "ui-valores-subcampo" }
const _hoisted_38 = { title: "Lucros Cessantes" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "ui-valores-subcampo-interno" }
const _hoisted_41 = { title: "Receita Bruta Anual" }
const _hoisted_42 = { class: "ui-valores-subcampo-interno" }
const _hoisted_43 = { title: "Período Indenitário" }
const _hoisted_44 = {
  key: 0,
  class: "ui-valores-periodo"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "meses", -1))
const _hoisted_46 = { class: "ui-valores-subcampo-interno" }
const _hoisted_47 = { title: "LMI Pretendido" }
const _hoisted_48 = { class: "ui-valores-subcampo-interno" }
const _hoisted_49 = { title: "Observações" }
const _hoisted_50 = { class: "ant-row ui-espaco-campos" }
const _hoisted_51 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_52 = { title: "6. Sinistralidade - Últimos três anos" }
const _hoisted_53 = { title: "Observações" }
const _hoisted_54 = { class: "ant-row ui-espaco-campos" }
const _hoisted_55 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { title: "7. Franquias Desejadas" }, " 7. Franquias Desejadas: ", -1))
const _hoisted_57 = { class: "ui-valores-opcoes" }
const _hoisted_58 = { title: "Observações" }
const _hoisted_59 = { class: "ant-row ui-espaco-campos" }
const _hoisted_60 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { title: "8. Opções de Apresentação de valor de Vigências" }, " 8. Opções de Apresentação de valor de Vigências: ", -1))
const _hoisted_62 = { class: "ui-valores-opcoes" }
const _hoisted_63 = { title: "Observações" }
const _hoisted_64 = { class: "ant-row ui-espaco-campos" }
const _hoisted_65 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { title: "Observações Gerais ao Subscritor" }, " Observações Gerais ao Subscritor: ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!
  const _component_inspecao_valores_arquivos = _resolveComponent("inspecao-valores-arquivos")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_card, {
      titulo: "INFORMAÇÕES GERAIS DE VALORES",
      "class-titulo": 'ui-card-info-titulo-rope'
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_component_campo_numerico, {
                    valor: _ctx.computedInspecaoValores.valorTargetPremio,
                    "onUpdate:valor": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedInspecaoValores.valorTargetPremio) = $event)),
                    monetario: true,
                    disabled: _ctx.props.bloquearCampos
                  }, null, 8, ["valor", "disabled"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_5, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Apresentar este campo no relatório?"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedInspecaoValores.observacoesValorTargetPremioVisivel,
                            "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesValorTargetPremioVisivel) = $event))
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Observações: ")
                    ]),
                    (_ctx.computedInspecaoValores.observacoesValorTargetPremioVisivel)
                      ? (_openBlock(), _createBlock(_component_a_textarea, {
                          key: 0,
                          "auto-size": true,
                          value: _ctx.computedInspecaoValores.observacoesValorTargetPremio,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesValorTargetPremio) = $event)),
                          disabled: _ctx.props.bloquearCampos
                        }, null, 8, ["value", "disabled"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, [
                    _createTextVNode(" 2. Seguro Novo ou Renovação: "),
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.computedInspecaoValores.seguroNovo,
                      onClick: _ctx.selecionarSeguroNovo
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Novo")
                      ]),
                      _: 1
                    }, 8, ["checked", "onClick"]),
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.computedInspecaoValores.seguroRenovacao,
                      onClick: _ctx.selecionarSeguroRenovacao
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Renovação")
                      ]),
                      _: 1
                    }, 8, ["checked", "onClick"])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_9, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Apresentar este campo no relatório?"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedInspecaoValores.observacoesSeguroNovoRenovacaoVisivel,
                            "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesSeguroNovoRenovacaoVisivel) = $event))
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Observações: ")
                    ]),
                    (_ctx.computedInspecaoValores.observacoesSeguroNovoRenovacaoVisivel)
                      ? (_openBlock(), _createBlock(_component_a_textarea, {
                          key: 0,
                          "auto-size": true,
                          value: _ctx.computedInspecaoValores.observacoesSeguroNovoRenovacao,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesSeguroNovoRenovacao) = $event)),
                          disabled: _ctx.props.bloquearCampos
                        }, null, 8, ["value", "disabled"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedInspecaoValores.ciaSeguradoraAtual) = $event)),
                    disabled: _ctx.props.bloquearCampos
                  }, null, 8, _hoisted_13), [
                    [_vModelText, _ctx.computedInspecaoValores.ciaSeguradoraAtual]
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_14, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Apresentar este campo no relatório?"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedInspecaoValores.observacoesCiaSeguradoraAtualVisivel,
                            "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesCiaSeguradoraAtualVisivel) = $event))
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Observações: ")
                    ]),
                    (_ctx.computedInspecaoValores.observacoesCiaSeguradoraAtualVisivel)
                      ? (_openBlock(), _createBlock(_component_a_textarea, {
                          key: 0,
                          "auto-size": true,
                          value: _ctx.computedInspecaoValores.observacoesCiaSeguradoraAtual,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesCiaSeguradoraAtual) = $event)),
                          disabled: _ctx.props.bloquearCampos
                        }, null, 8, ["value", "disabled"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_selecionar_data, {
                    "data-selecionada": _ctx.computedInspecaoValores.dataVigenciaRenovacao,
                    "onUpdate:dataSelecionada": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.computedInspecaoValores.dataVigenciaRenovacao) = $event)),
                    disabled: _ctx.props.bloquearCampos
                  }, null, 8, ["data-selecionada", "disabled"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_18, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Apresentar este campo no relatório?"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedInspecaoValores.observacoesDataVigenciaRenovacaoVisivel,
                            "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesDataVigenciaRenovacaoVisivel) = $event))
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Observações: ")
                    ]),
                    (_ctx.computedInspecaoValores.observacoesDataVigenciaRenovacaoVisivel)
                      ? (_openBlock(), _createBlock(_component_a_textarea, {
                          key: 0,
                          "auto-size": true,
                          value: _ctx.computedInspecaoValores.observacoesDataVigenciaRenovacao,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesDataVigenciaRenovacao) = $event)),
                          disabled: _ctx.props.bloquearCampos
                        }, null, 8, ["value", "disabled"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_campo_numerico, {
                    valor: _ctx.computedInspecaoValores.valoresEmRiscoTotal,
                    "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedInspecaoValores.valoresEmRiscoTotal) = $event)),
                    monetario: true,
                    disabled: _ctx.props.bloquearCampos
                  }, null, 8, ["valor", "disabled"]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Apresentar este campo no relatório?"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedInspecaoValores.vrPredioVisivel,
                            "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.computedInspecaoValores.vrPredioVisivel) = $event))
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" VR - Prédio (Estrutura) ")
                    ]),
                    (_ctx.computedInspecaoValores.vrPredioVisivel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _hoisted_25,
                          _createVNode(_component_campo_numerico, {
                            valor: _ctx.computedInspecaoValores.vrPredio,
                            "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.computedInspecaoValores.vrPredio) = $event)),
                            monetario: true,
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["valor", "disabled"]),
                          _createElementVNode("label", _hoisted_26, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "Apresentar este campo no relatório?"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_checkbox, {
                                  checked: _ctx.computedInspecaoValores.observacoesVrPredioVisivel,
                                  "onUpdate:checked": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesVrPredioVisivel) = $event))
                                }, null, 8, ["checked"])
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" Observações: ")
                          ]),
                          (_ctx.computedInspecaoValores.observacoesVrPredioVisivel)
                            ? (_openBlock(), _createBlock(_component_a_textarea, {
                                key: 0,
                                "auto-size": true,
                                value: _ctx.computedInspecaoValores.observacoesVrPredio,
                                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesVrPredio) = $event)),
                                disabled: _ctx.props.bloquearCampos
                              }, null, 8, ["value", "disabled"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", _hoisted_28, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Apresentar este campo no relatório?"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedInspecaoValores.vrConteudoVisivel,
                            "onUpdate:checked": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.computedInspecaoValores.vrConteudoVisivel) = $event))
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" VR - Conteúdo (Máquinas, equipamentos, móveis, utensílios, instalações e demais bens) ")
                    ]),
                    (_ctx.computedInspecaoValores.vrConteudoVisivel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("label", _hoisted_30, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "Apresentar este campo no relatório?"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_checkbox, {
                                  checked: _ctx.computedInspecaoValores.vrConteudoValorVisivel,
                                  "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.computedInspecaoValores.vrConteudoValorVisivel) = $event))
                                }, null, 8, ["checked"])
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" Valor: ")
                          ]),
                          (_ctx.computedInspecaoValores.vrConteudoValorVisivel)
                            ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                key: 0,
                                valor: _ctx.computedInspecaoValores.vrConteudoValor,
                                "onUpdate:valor": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.computedInspecaoValores.vrConteudoValor) = $event)),
                                monetario: true,
                                disabled: _ctx.props.bloquearCampos
                              }, null, 8, ["valor", "disabled"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("label", _hoisted_31, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "Apresentar este campo no relatório?"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_checkbox, {
                                  checked: _ctx.computedInspecaoValores.observacoesVrConteudoVisivel,
                                  "onUpdate:checked": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesVrConteudoVisivel) = $event))
                                }, null, 8, ["checked"])
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" Observações: ")
                          ]),
                          (_ctx.computedInspecaoValores.observacoesVrConteudoVisivel)
                            ? (_openBlock(), _createBlock(_component_a_textarea, {
                                key: 1,
                                "auto-size": true,
                                value: _ctx.computedInspecaoValores.observacoesVrConteudo,
                                "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesVrConteudo) = $event)),
                                disabled: _ctx.props.bloquearCampos
                              }, null, 8, ["value", "disabled"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("label", _hoisted_33, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Apresentar este campo no relatório?"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedInspecaoValores.vrEstoquesVisivel,
                            "onUpdate:checked": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.computedInspecaoValores.vrEstoquesVisivel) = $event))
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" VR - Estoques (Matéria-prima, produtos em processo, acabados, embalagens e materiais auxiliares) ")
                    ]),
                    (_ctx.computedInspecaoValores.vrEstoquesVisivel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("label", _hoisted_35, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "Apresentar este campo no relatório?"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_checkbox, {
                                  checked: _ctx.computedInspecaoValores.vrEstoquesValorVisivel,
                                  "onUpdate:checked": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.computedInspecaoValores.vrEstoquesValorVisivel) = $event))
                                }, null, 8, ["checked"])
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" Valor: ")
                          ]),
                          (_ctx.computedInspecaoValores.vrEstoquesValorVisivel)
                            ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                key: 0,
                                valor: _ctx.computedInspecaoValores.vrEstoquesValor,
                                "onUpdate:valor": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.computedInspecaoValores.vrEstoquesValor) = $event)),
                                monetario: true,
                                disabled: _ctx.props.bloquearCampos
                              }, null, 8, ["valor", "disabled"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("label", _hoisted_36, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "Apresentar este campo no relatório?"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_checkbox, {
                                  checked: _ctx.computedInspecaoValores.observacoesVrEstoquesVisivel,
                                  "onUpdate:checked": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesVrEstoquesVisivel) = $event))
                                }, null, 8, ["checked"])
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" Observações: ")
                          ]),
                          (_ctx.computedInspecaoValores.observacoesVrEstoquesVisivel)
                            ? (_openBlock(), _createBlock(_component_a_textarea, {
                                key: 1,
                                "auto-size": true,
                                value: _ctx.computedInspecaoValores.observacoesVrEstoques,
                                "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesVrEstoques) = $event)),
                                disabled: _ctx.props.bloquearCampos
                              }, null, 8, ["value", "disabled"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("label", _hoisted_38, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Apresentar este campo no relatório?"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedInspecaoValores.lucrosCessantesVisivel,
                            "onUpdate:checked": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.computedInspecaoValores.lucrosCessantesVisivel) = $event))
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Lucros Cessantes ")
                    ]),
                    (_ctx.computedInspecaoValores.lucrosCessantesVisivel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("label", _hoisted_41, [
                              _createVNode(_component_a_tooltip, {
                                placement: "top",
                                title: "Apresentar este campo no relatório?"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_checkbox, {
                                    checked: _ctx.computedInspecaoValores.lucrosCessantesReceitaBrutaAnualVisivel,
                                    "onUpdate:checked": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.computedInspecaoValores.lucrosCessantesReceitaBrutaAnualVisivel) = $event))
                                  }, null, 8, ["checked"])
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" Receita Bruta Anual: ")
                            ]),
                            (_ctx.computedInspecaoValores.lucrosCessantesReceitaBrutaAnualVisivel)
                              ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                  key: 0,
                                  valor: _ctx.computedInspecaoValores.lucrosCessantesReceitaBrutaAnualValor,
                                  "onUpdate:valor": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.computedInspecaoValores.lucrosCessantesReceitaBrutaAnualValor) = $event)),
                                  monetario: true,
                                  disabled: _ctx.props.bloquearCampos
                                }, null, 8, ["valor", "disabled"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("label", _hoisted_43, [
                              _createVNode(_component_a_tooltip, {
                                placement: "top",
                                title: "Apresentar este campo no relatório?"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_checkbox, {
                                    checked: _ctx.computedInspecaoValores.periodoIdenitarioVisivel,
                                    "onUpdate:checked": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.computedInspecaoValores.periodoIdenitarioVisivel) = $event))
                                  }, null, 8, ["checked"])
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" Período Indenitário: ")
                            ]),
                            (_ctx.computedInspecaoValores.periodoIdenitarioVisivel)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                  _createVNode(_component_campo_numerico, {
                                    valor: _ctx.computedInspecaoValores.periodoIdenitarioMeses,
                                    "onUpdate:valor": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.computedInspecaoValores.periodoIdenitarioMeses) = $event)),
                                    monetario: false,
                                    "quantidade-casas-decimais": 0,
                                    disabled: _ctx.props.bloquearCampos
                                  }, null, 8, ["valor", "disabled"]),
                                  _hoisted_45
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("label", _hoisted_47, [
                              _createVNode(_component_a_tooltip, {
                                placement: "top",
                                title: "Apresentar este campo no relatório?"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_checkbox, {
                                    checked: _ctx.computedInspecaoValores.lmiPretendidoVisivel,
                                    "onUpdate:checked": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.computedInspecaoValores.lmiPretendidoVisivel) = $event))
                                  }, null, 8, ["checked"])
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" LMI Pretendido: ")
                            ]),
                            (_ctx.computedInspecaoValores.lmiPretendidoVisivel)
                              ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                  key: 0,
                                  valor: _ctx.computedInspecaoValores.lmiPretendidoValor,
                                  "onUpdate:valor": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.computedInspecaoValores.lmiPretendidoValor) = $event)),
                                  monetario: true,
                                  disabled: _ctx.props.bloquearCampos
                                }, null, 8, ["valor", "disabled"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("label", _hoisted_49, [
                              _createVNode(_component_a_tooltip, {
                                placement: "top",
                                title: "Apresentar este campo no relatório?"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_checkbox, {
                                    checked: _ctx.computedInspecaoValores.observacoesLucroCessantesVisivel,
                                    "onUpdate:checked": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesLucroCessantesVisivel) = $event))
                                  }, null, 8, ["checked"])
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" Observações: ")
                            ]),
                            (_ctx.computedInspecaoValores.observacoesLucroCessantesVisivel)
                              ? (_openBlock(), _createBlock(_component_a_textarea, {
                                  key: 0,
                                  "auto-size": true,
                                  value: _ctx.computedInspecaoValores.observacoesLucroCessantes,
                                  "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesLucroCessantes) = $event)),
                                  disabled: _ctx.props.bloquearCampos
                                }, null, 8, ["value", "disabled"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("label", _hoisted_52, [
                    _createTextVNode(" 6. Sinistralidade - Últimos três anos: "),
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.computedInspecaoValores.sinistralidadeUltimosAnosSim,
                      onClick: _ctx.selecionarSinistralidadeSim
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Sim")
                      ]),
                      _: 1
                    }, 8, ["checked", "onClick"]),
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.computedInspecaoValores.sinistralidadeUltimosAnosNao,
                      onClick: _ctx.selecionarSinistralidadeNao
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Não")
                      ]),
                      _: 1
                    }, 8, ["checked", "onClick"])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_53, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Apresentar este campo no relatório?"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedInspecaoValores.observacoesSinistralidadeUltimosAnosNaoVisivel,
                            "onUpdate:checked": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesSinistralidadeUltimosAnosNaoVisivel) = $event))
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Observações: ")
                    ]),
                    (_ctx.computedInspecaoValores.observacoesSinistralidadeUltimosAnosNaoVisivel)
                      ? (_openBlock(), _createBlock(_component_a_textarea, {
                          key: 0,
                          "auto-size": true,
                          value: _ctx.computedInspecaoValores.observacoesSinistralidadeUltimosAnosNao,
                          "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesSinistralidadeUltimosAnosNao) = $event)),
                          disabled: _ctx.props.bloquearCampos
                        }, null, 8, ["value", "disabled"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.computedInspecaoValores.franquiaReduzida,
                      "onUpdate:checked": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.computedInspecaoValores.franquiaReduzida) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Reduzida")
                      ]),
                      _: 1
                    }, 8, ["checked"]),
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.computedInspecaoValores.franquiaNormal,
                      "onUpdate:checked": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.computedInspecaoValores.franquiaNormal) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Normal")
                      ]),
                      _: 1
                    }, 8, ["checked"]),
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.computedInspecaoValores.franquiaMajorada,
                      "onUpdate:checked": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.computedInspecaoValores.franquiaMajorada) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Majorada")
                      ]),
                      _: 1
                    }, 8, ["checked"])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_58, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Apresentar este campo no relatório?"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedInspecaoValores.observacoesFranquiaVisivel,
                            "onUpdate:checked": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesFranquiaVisivel) = $event))
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Observações: ")
                    ]),
                    (_ctx.computedInspecaoValores.observacoesFranquiaVisivel)
                      ? (_openBlock(), _createBlock(_component_a_textarea, {
                          key: 0,
                          "auto-size": true,
                          value: _ctx.computedInspecaoValores.observacoesFranquia,
                          "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesFranquia) = $event)),
                          disabled: _ctx.props.bloquearCampos
                        }, null, 8, ["value", "disabled"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _hoisted_61,
                  _createElementVNode("div", _hoisted_62, [
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.computedInspecaoValores.apresentacaoValorVigencia12Meses,
                      "onUpdate:checked": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.computedInspecaoValores.apresentacaoValorVigencia12Meses) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("12 meses")
                      ]),
                      _: 1
                    }, 8, ["checked"]),
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.computedInspecaoValores.apresentacaoValorVigencia18Meses,
                      "onUpdate:checked": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.computedInspecaoValores.apresentacaoValorVigencia18Meses) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("18 meses")
                      ]),
                      _: 1
                    }, 8, ["checked"]),
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.computedInspecaoValores.apresentacaoValorVigencia24Meses,
                      "onUpdate:checked": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.computedInspecaoValores.apresentacaoValorVigencia24Meses) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("24 meses")
                      ]),
                      _: 1
                    }, 8, ["checked"])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_63, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Apresentar este campo no relatório?"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedInspecaoValores.observacoesApresentacaoValorVigenciaVisivel,
                            "onUpdate:checked": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesApresentacaoValorVigenciaVisivel) = $event))
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Observações: ")
                    ]),
                    (_ctx.computedInspecaoValores.observacoesApresentacaoValorVigenciaVisivel)
                      ? (_openBlock(), _createBlock(_component_a_textarea, {
                          key: 0,
                          "auto-size": true,
                          value: _ctx.computedInspecaoValores.observacoesApresentacaoValorVigencia,
                          "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesApresentacaoValorVigencia) = $event)),
                          disabled: _ctx.props.bloquearCampos
                        }, null, 8, ["value", "disabled"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createVNode(_component_a_textarea, {
                    rows: 8,
                    value: _ctx.computedInspecaoValores.observacoesGerais,
                    "onUpdate:value": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.computedInspecaoValores.observacoesGerais) = $event)),
                    disabled: _ctx.props.bloquearCampos
                  }, null, 8, ["value", "disabled"])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_inspecao_valores_arquivos, {
      arquivos: _ctx.computedInspecaoValores.arquivos,
      "onUpdate:arquivos": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.computedInspecaoValores.arquivos) = $event)),
      "codigo-inspecao-valores": _ctx.computedInspecaoValores.codigo,
      "bloquear-campos": _ctx.props.bloquearCampos
    }, null, 8, ["arquivos", "codigo-inspecao-valores", "bloquear-campos"])
  ]))
}